export default __webpack_public_path__ + "static/media/thailand_post.5d0c31b0.png";